import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class PneumaticalSlidingDoors extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        Türtyp:
                    </Typography>
                </Grid>
                <Grid item xs={10}>
                    <FormRadio
                        name="sliding_door"
                        options={[
                            {
                                value : 'single_wing',
                                label : 'Einflügelige Schiebetür',
                            },
                            {
                                value : 'double_wing',
                                label : 'Zweiflügelige Schiebetür',
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.sliding_door || ''}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        type="text"
                        name="producer"
                        label='Hersteller:'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.producer}
                        inputProps={{
                            maxLength : 20,
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        name="product_id"
                        label='Produktidentifikationsnummer:'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.product_id}
                        inputProps={{
                            maxLength : 20,
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        name="door_designation"
                        label='Türbezeichnung:'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.door_designation}
                        inputProps={{
                            maxLength : 20,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        type="text"
                        name="operator"
                        label='Betreiber und Betriebsort:'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.operator}
                        inputProps={{
                            maxLength : 32,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        1.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_1_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_1_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        1.2
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_2_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_2_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_1_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_1_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        1.3
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_3_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_3_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_1_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_1_content_3 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        1.4
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_4_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_4_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_1_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_1_content_4 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        1.5
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_5_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_1_content_5_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_1_content_5"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_1_content_5 || ''}
                    />
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        2.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_2_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_2_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        2.2
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_2_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_2_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_2_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_2_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        2.3
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_3_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_3_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_2_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_2_content_3 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        2.4
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_4_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_4_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_2_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_2_content_4 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        2.5
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_5_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_5_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_2_content_5"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_2_content_5 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        2.6
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_6_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_6_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_2_content_6"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_2_content_6 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        2.7
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_7_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_2_content_7_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_2_content_7"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_2_content_7 || ''}
                    />
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        3.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_3_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_3_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        3.2
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_2_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_2_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_3_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_3_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        3.3
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_3_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_3_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_3_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_3_content_3 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        3.4
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_4_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_4_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_3_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_3_content_4 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        3.5
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_5_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_5_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_3_content_5"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_3_content_5 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        3.6
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_6_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_3_content_6_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_3_content_6"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_3_content_6 || ''}
                    />
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        4.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_4_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_4_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        4.2
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4_content_2_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4_content_2_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_4_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_4_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        4.3
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4_content_3_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4_content_3_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_4_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_4_content_3 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        4.4
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4_content_4_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_4_content_4_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_4_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_4_content_4 || ''}
                    />
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        5.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_5_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_5_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        5.2
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_2_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_2_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_5_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_5_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        5.3
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_3_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_3_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_5_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_5_content_3 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        5.4
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_4_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_4_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_5_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_5_content_4 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        5.5
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_5_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_5_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_5_content_5"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_5_content_5 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        5.6
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_6_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_5_content_6_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_5_content_6"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_5_content_6 || ''}
                    />
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        6.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_6_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_6_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        6.2
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6_content_2_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6_content_2_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_6_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_6_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        6.3
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6_content_3_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6_content_3_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_6_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_6_content_3 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        6.4
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6_content_4_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_6_content_4_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_6_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_6_content_4 || ''}
                    />
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        7.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_7_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_7_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        7.2
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_2_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_2_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_7_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_7_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        7.3
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_3_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_3_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_7_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_7_content_3 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        7.4
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_4_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_4_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_7_content_4"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_7_content_4 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        7.5
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_5_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_5_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_7_content_5"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_7_content_5 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        7.6
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_6_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_7_content_6_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_7_content_6"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_7_content_6 || ''}
                    />
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_8')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        8.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_8_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_8_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_8_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_8_content_1 || ''}
                    />
                </Grid>

                <Grid item xs={9}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_9')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        9.1
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_9_content_1_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_9_content_1_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_9_content_1"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_9_content_1 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        9.2
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_9_content_2_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_9_content_2_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_9_content_2"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_9_content_2 || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        9.3
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_9_content_3_part_1')}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component={"div"}
                                variant={"body1"}>
                        {i18n.get('protocols.pneumaticalDoors.heading_9_content_3_part_2')}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormRadio
                        name="heading_9_content_3"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            },
                            {
                                value : 'inapplicable',
                                label : 'n.a.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.heading_9_content_3 || ''}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormField
                        type="text"
                        name="heading_10"
                        label={i18n.get('protocols.pneumaticalDoors.heading_10')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.heading_10}
                    />
                </Grid>


                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    formRadio: {
        flexDirection: "row",
        marginTop: '10px',
    },
    formRadioSelection: {
        flexDirection: "row",
        marginTop: '5px',
    },
    formButton: {
        marginLeft: '175px'
    },
    formSelection: {
    },
});

export default withStyles(styles)(PneumaticalSlidingDoors)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/PneumaticalSlidingDoors.js